<div class="adx-lib-widget-add-wrapper">
    <div class="adx-vmailbox-widget">

    </div>
</div>
